import Button from "@/components/Button";
import {
  compactGlobalToolbarBorderlessIconStyle,
  globalToolbarIconButtonWrapClassName
} from "@/components/Button/globalAddButtonFilledStyle";
import { compactGlobalNavbarIconBoxClassName } from "@/components/TopActionBar/compactNavbarChrome";
import { globalSearchAriaShortcut } from "@/lib/keyboardShortcuts";
import classNames from "classnames";

export interface ToolbarQuickSearchButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  testId?: string;
}

export default function ToolbarQuickSearchButton({
  onClick,
  disabled = false,
  testId = "quick-search-button"
}: ToolbarQuickSearchButtonProps) {
  return (
    <span className={classNames(globalToolbarIconButtonWrapClassName, compactGlobalNavbarIconBoxClassName)}>
      <Button
        variant="outlined"
        icon="search"
        iconWeight={800}
        ariaLabel="Search"
        ariaKeyShortcuts={globalSearchAriaShortcut()}
        testId={testId}
        onClick={onClick}
        disabled={disabled}
        style={compactGlobalToolbarBorderlessIconStyle}
      />
    </span>
  );
}
